import { InputBaseComponentProps } from "@mui/material/InputBase";
import { InputProps as StandardInputProps } from "@mui/material/Input/Input";
import { TextMaskCustom } from "./TextMaskFacade";

export const UPPERCASE_INPUT = {
  style: { textTransform: "uppercase" },
} as InputBaseComponentProps;

export const textMaskTextFieldInputProps: StandardInputProps = {
  inputComponent: TextMaskCustom as any,
  inputProps: {
    mask: "00:00",
    definitions: {
      "#": /[0-9]/,
    },
  },
};
